import { JDSBadgeV2Props } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSBadgeV2Props>
  ): React.FC<JDSBadgeV2Props> =>
  (props: JDSBadgeV2Props) => {
    return (
      <Component {...{ ...props, _hasChildrenSlot: Boolean(props.children) }} />
    );
  };
